import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { filter, first, map } from 'rxjs';
import { UserService } from '../modules/admin/services/user.service';
import { User } from '../modules/admin/models/user';

export const roleGuardFn: CanActivateFn = (route: ActivatedRouteSnapshot) => {

    const userService = inject(UserService);
    const router = inject(Router);

    const requiredPermissions: PermissionRequirements = route.data['requiredPermissions'] ?? PermissionRequirements.all([]);

    return userService.getCurrentUser()
                      .pipe(
                            filter((user): user is User => user !== undefined),
                            first(),
                            map(user => {

                                const hasAccess = requiredPermissions.isSatisfiedBy(permission => user.hasPermission(permission));

                                if (hasAccess) {
                                    return true;
                                }

                                router.navigate(['/dashboard']);

                                return false;
                            })
                       );
};

export type PermissionRequirementKind = 'all' | 'any';

export class PermissionRequirements {
    constructor(
        public readonly permissions: string[],
        public readonly kind: PermissionRequirementKind
    ) { }

    static all(permissions: string[]): PermissionRequirements {
        return new PermissionRequirements(permissions, 'all');
    }

    static any(permissions: string[]): PermissionRequirements {
        return new PermissionRequirements(permissions, 'any');
    }

    isSatisfiedBy(hasPermission: (permission: string) => boolean): boolean {
        switch (this.kind) {
            case 'all':
                return this.permissions.every(hasPermission);
            case 'any':
                return this.permissions.some(hasPermission);
        }
    }
}
